import { render, staticRenderFns } from "./MopModuleItem.vue?vue&type=template&id=236f1f3a&scoped=true"
import script from "./MopModuleItem.vue?vue&type=script&lang=js"
export * from "./MopModuleItem.vue?vue&type=script&lang=js"
import style0 from "./MopModuleItem.vue?vue&type=style&index=0&id=236f1f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f1f3a",
  null
  
)

export default component.exports